import commonConstant from '../../common/_commonConstant';

export const getCompany = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_COMPANY_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_COMPANY_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
